import adminModule from "./adminModule/actions";
import subscription from "./subscription/actions";

export default {
  ...adminModule,
  ...subscription,
};
